import styled from 'styled-components'
import { Icon } from '../../atoms/Icon/Icon.styles'

export const SearchInputWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  background: ${({ theme }) => theme.palette.grayscale['100']};
  border: 1px solid ${({ theme }) => theme.palette.grayscale['100']};
  padding: ${({ theme }) => theme.rem(8)} ${({ theme }) => theme.rem(12)};
  border-radius: ${({ theme }) => theme.rem(4)};
  overflow: hidden;
`

export const SearchInputLabel = styled.label`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`

export const SearchInputIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.palette.grayscale['500']};

  ${Icon} {
    font-size: ${({ theme }) => theme.rem(20)};
  }

  ${({ theme }) => theme.mediaQuery.lg(`
    padding-left: ${({ theme }) => theme.rem(16)};
  `)}
`

export const SearchInputField = styled.input`
  flex: 1;
  padding: ${({ theme }) => `${theme.rem(0)} ${theme.rem(20)}`};
  border: none;
  background: ${({ theme }) => theme.palette.grayscale['100']};
  font-size: ${({ theme }) => theme.rem(16)};
  color: ${({ theme }) => theme.palette.grayscale['500']};
  outline: none;

  &::placeholder {
    color: ${({ theme }) => theme.palette.grayscale['500']};
  }
`

export const SearchInputButton = styled.button`
  display: none;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.rem(32)};
  height: ${({ theme }) => theme.rem(32)};
  margin: ${({ theme }) => theme.rem(4)};
  border: none;
  border-radius: ${({ theme }) => theme.rem(6)};
  background: ${({ theme }) => theme.palette.green['300']};
  color: ${({ theme }) => theme.palette.grayscale['50']};
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.palette.green['200']};
  }

  &:disabled {
    background: ${({ theme }) => theme.palette.grayscale['200']};
    cursor: not-allowed;
  }

  svg {
    width: ${({ theme }) => theme.rem(20)};
    height: ${({ theme }) => theme.rem(20)};
  }

  ${({ theme }) => theme.mediaQuery.lg(`
    display: flex;
  `)}
`
